<script setup>
import Navbar from '@/components/NavbarView.vue';
import router from '@/router';
import { ref } from 'vue'

const workListData = ref([
  {
    title: '标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1标题1',
    content: '这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,这是标题1的内容,'
  },
  {
    title: '标题2',
    content: '这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,这是标题2的内容,'
  },
  {
    title: '标题3',
    content: '这是标题3的内容,这是标题3的内容,这是标题3的内容,这是标题3的内容,这是标题3的内容,这是标题3的内容,这是标题3的内容,这是标题3的内容'
  },
  {
    title: '标题4',
    content: '这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,这是标题4的内容,'
  },
  {
    title: '标题5',
    content: '这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,这是标题5的内容,'
  }
])


const showWorkDetail = (item) => {
  router.push({ name: 'ReviewDetail' })
  // , params: { id: item.title }
}


const srcList = ref([
  'https://www.aixlab.cn/images/cover/AI.jpeg',
  'https://www.cnmaker.org.cn/resource/images/product_img.png'
])

const showViewer = ref(false)
const viewerIndex = ref(0)

const openImageViewer = (index) => {
  viewerIndex.value = index
  showViewer.value = true
}
</script>

<template>
  <Navbar />
  
  <h2 style="text-align: center;">作品一览</h2>
  <div class="container">
    <el-card class="box-card" v-for="item in workListData" :key="item.title">
      <template #header>
        <div class="card-header">
            <el-text truncated>
              <span>{{ item.title }}</span>
            </el-text>
          <el-button class="button" type="text" @click="showWorkDetail(item)">了解更多</el-button>
        </div>
      </template>
      <div>
        <div class="carousel">
          <el-carousel height="200px" arrow="always">
            <el-carousel-item v-for="(src, index) in srcList" :key="index"
              style="display: flex; justify-content: center; align-items: center;">
              <el-image style="max-width: 100%; height: 100%;object-fit: contain;"
                @click="openImageViewer(index)"
                :src="src"/>
            </el-carousel-item>
          </el-carousel>
          
        </div>
        <el-divider/>
        <el-text line-clamp="4">
          {{ item.content }}
        </el-text>
      </div>
    </el-card>
  </div>

  <el-image-viewer
    v-if="showViewer"
    :url-list="srcList"
    :initial-index="viewerIndex"
    @close="showViewer = false"
  />
</template>

<style scoped>

.carousel {
  width: 80%;
  margin: 0 auto;
}

.container{
  width:80%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 20px auto;
  /* justify-content: center; */
  /* align-items: center;
  flex-wrap: wrap; */
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  /* width: 33%; */
  /* margin-bottom: 20px; */
}

:deep(.el-card){
  border-radius: 15px;
}

.el-text {
  color: #303133;
  font-size: 16px;
}

</style>